import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, EventEmitter, input, Output } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-delete-button',
  standalone: true,
  imports: [CommonModule, TranslateModule],
  templateUrl: './delete-button.component.html',
  styleUrl: './delete-button.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class DeleteButtonComponent {
  readonly hasPermission = input<boolean>(false);

  @Output() readonly onDeleteClicked = new EventEmitter<void>();

  /**
   * Emits the search data event.
   *
   * @returns void
   */
  public onSubmit(): void {
    this.onDeleteClicked.emit();
  }
}
